<template>

  <div class="ctn-center">

    <div id="alert_message" class="d-none alert alert-dismissible alert-modal" role="alert"
      v-bind:class="message_type">
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      {{message}}
    </div>

    <div id="quiz" class="p-5 w-100">

      <img class="png-160-160" src="/modules/dlnkgames/img/mois_des_femmes.jpeg">

      <div class="tlt-qz">
        <h1 class="text-black">{{ game.name }}</h1>
      </div>

      <div id="presentation" v-if="step === 'presentation'">

        <div class="container" v-html="game.description"></div>

<!--        <a class="btn btn-primary" target="_blank" href="https://csam.zemust.fr/content/13-reglement-du-quiz">-->
<!--          Réglement du Quiz-->
<!--        </a>-->

        <br>
<!--        <button class="mt-4 bg-button" @click="step = 'start'">Commencez le Quiz et accepter le réglement</button>-->
        <button class="mt-4 bg-button" @click="step = 'start'">Commencez le Quizz</button>

      </div>

      <div id="start" v-else-if="step === 'start'">

        <div class="ctn-sub-title">
          <p class="style-light">
            Comuniquez-nous vos coordonnés pour être mis au courant des prix gagnants disponibles
          </p>
        </div>

        <form action="" method="post" id="user_form" class="needs-validation" novalidate>
          <div class="container">

            <div class="row">

              <input type="hidden" id="customer_id" class="form-control" :value="customer.id">

              <div class="form-group col-md-6 row">
                <label class="pl-0 mb-0 col-md-4 text-left text-md-right" for="firstname">Prénom :</label>
                <input type="text" id="firstname" class="form-control col-md-8" required placeholder="Prénom"
                       v-model="firstname">
                <div class="invalid-feedback">
                  Veuillez renseigner votre prénom
                </div>

              </div>

              <div class="form-group col-md-6 row">
                <label class="text-left text-md-right pl-0 mb-0 col-md-4 required" for="lastname">Nom :</label>
                <input type="text" id="lastname" class="form-control col-md-8" required placeholder="Nom"
                       v-model="lastname">
                <div class="invalid-feedback">
                  Veuillez renseigner nom de famille.
                </div>

              </div>

              <div class="form-group col-md-6 row">
                <label class="pl-0 mb-0 col-md-4 text-left text-md-right" for="phone">Téléphone :</label>
                <input type="tel" id="phone" class="form-control col-md-8" required placeholder="Téléphone"
                       minlength="10" maxlength="14" pattern="^0[1-9]( ?\d{2}){4}"
                       v-model="phone">
                <div id="phone_feedback" class="invalid-feedback">
                  Veuillez renseigner votre numéro de téléphone (format : XX XX XX XX XX).
                  Ce numéro est nécessaire pour recevoir votre lot.
                </div>
              </div>

              <div class="form-group col-md-6 row">
                <label class="pl-0 mb-0 col-md-4 text-left text-md-right" for="email">Email :</label>
                <input type="email" id="email" class="form-control col-md-8"
                       v-model="email">
                <div class="invalid-feedback">
                  Veuillez renseigner une adresse email correct
                </div>
              </div>

            </div>
          </div>

          <button type="submit" name="set_user" class="bg-button" @click="start_quiz($event)">Démarrez le Quiz</button>

        </form>

      </div>

      <div id="choices" v-else-if="step === 'quiz'">

        <div class="container col-12">

          <div class="d-flex flex-row justify-content-between p-0 p-md-2">

            <div @click="previous_question()">
              <img class="svg-left" alt="question précédente" src="/modules/dlnkgames/img/down-arrow.svg">
            </div>

            <div class="col-sm-8">
              <p id="progress" class="dinkgames-progress-quiz">Question {{ current_question_index + 1 }} /
                {{ question_count }}</p>
            </div>

            <div @click="next_question()">
              <img alt="question suivant" class="svg-right" src="/modules/dlnkgames/img/down-arrow.svg">
            </div>

          </div>
        </div>

        <div class="container">
          <h2 class="center_focus_strong h3" id="question">
            {{ current_question.title }}
          </h2>

          <div class="row justify-content-center">
            <button v-for="choice in current_choices" class="btn-quiz col-6"
                    :key="choice.id"
                    v-bind:class="{ 'quiz-active': responses[current_question.id] == choice.id }"
                    @click="select_choice(choice.id)">
              <span>{{ choice.choice }}</span>
            </button>
          </div>
        </div>
      </div>

      <div id="validation" v-else-if="step === 'validation'" class="text-center mb-7">

        <p class="text-center">
          <strong>
            Vous avez terminé le quiz. <br>
            Mais ce n’est pas fini : <br>
          </strong>
          <br>
          validez le quiz pour terminer. <br>
        </p>

        <div class="mb-3">

          <button class="bg-button" name="submit_responses"
                  @click="post_responses()">
            Valider votre participation
          </button>
        </div>

<!--        <table class="table">-->
<!--          <thead>-->
<!--          <tr>-->
<!--            <th scope="col">Questions</th>-->
<!--            <th scope="col">Vos réponses</th>-->
<!--          </tr>-->
<!--          </thead>-->
<!--          <tbody>-->
<!--          <tr v-for="question in questions">-->
<!--            <td>{{ question.title }}</td>-->
<!--            <td>{{ choice_for_question(question.id).choice }}</td>-->
<!--          </tr>-->
<!--          </tbody>-->
<!--        </table>-->

      </div>

      <div id="congrats" v-else-if="step === 'congrats'" class="text-center mb-7 mt-2">
        <h1 class="text-black">Félicitation !</h1>

        <p class="text-center">
          Vous avez terminé le QUIZZ Égalité Filles-Garçons.
          <br>
          Merci pour votre participation.
          <br><br>
          <strong>Votre score est de {{score}}/10</strong>
          <br><br>
          Les résultats seront publiés à partir du <strong>04/04</strong>, les gagnants seront alors contactés par le CSAM.
        </p>

        <br><br>

        <div class="container">
          <strong>1. En France, une femme a toujours pu travailler sans l’autorisation de son mari</strong>
          <br>
          Réponse : <strong>Faux</strong>
          <p>
            Ce n’est que depuis 1965 qu’une femme est libre de travailler sans l’accord de son mari.
          </p>
          <br><br>
          <strong>2. Depuis 1958 avec la 5e République, combien de femmes ont été premier ministre ?</strong>
          <br>
          Réponse : <strong>1</strong>
          <br>
          <p>
            Une seule ! Il s’agit d’Édith Cresson, Premier ministre de François Mitterrand de mai 1991 à avril 1992.
          </p>
          <br><br>
          <strong>3.  Les garçons obtiennent, en moyenne, de meilleurs résultats que les filles en mathématiques :</strong>
          <br>
          Réponse : <strong>Faux</strong>
          <p>
            Les filles ont des compétences équivalentes à celles des garçons en mathématiques. En 2012, en fin de 3e ,
            88 % des garçons et 87 % des filles maîtrisent les compétences de base en mathématiques.
          </p>
          <br>
          <br>
          <strong>4. Tous temps de travail confondus, les salaires des femmes en France sont inférieurs à ceux des hommes :</strong>
          <br>
          Réponse : <strong>Vrai</strong>
          <p>
            Alors que le principe « à travail égal, salaire égal » est inscrit dans nombre de textes, l’écart entre les
            salaires des femmes et celui des hommes est de 25 %. Cet écart se creuse souvent en cours de carrière, quand
            une femme décide « de lever le pied », pour des raisons personnelles et/ou familiales. Ce n’est pas la seule
            explication ; il existe ce qu’on appelle le « plafond de verre ». C’est une paroi virtuelle qui désigne les
            barrières excluant les femmes des niveaux hiérarchiques les plus élevés en entreprise…
          </p>
          <br>
          <br>
          <strong>5. Depuis quelle année l’école publique est-elle mixte ?</strong>
          <br>
          Réponse : <strong>1975</strong>
          <p>
            La mixité ne devient obligatoire de la maternelle au lycée qu’en 1975, avec la loi Haby. L’université est
            quant à elle ouverte aux filles depuis l’avant-guerre mais dans les faits, peu de filles osent y entrer avant
            les années 1950-1960. Les grandes écoles suivent le mouvement mais lentement : Polytechnique en 1972, les Écoles
            Normales de la rue d’Ulm en… 1986 ! L’ENA est mixte depuis sa création, en 1946. Cependant, près de 40 ans plus
            tard, les choix d’orientation des filles et des garçons demeurent différents. En fonction des filières post-3e,
            la répartition des filles et des garçons dans les classes est très inégale.
          </p>
          <br>
          <br>
          <strong>6. Comment se partagent les tâches domestiques au sein du couple ?</strong>
          <br>
          Réponse : <strong>Les femmes y consacrent deux fois plus de temps que les hommes</strong>
          <p>
            Les femmes exécutent en moyenne les deux tiers de l’ensemble des tâches domestiques, ce qui représente presque
            4 heures par jour, là où les hommes y consacrent moins de deux heures et demie. La cuisine, le soin des enfants
            et le ménage demeurent le lot des femmes.
          </p>
          <br>
          <br>
          <strong>
            7. Quel est le point commun à toutes les inventions suivantes : l’essuie-glace, le silencieux de moteur, la
            scie circulaire, le gilet pare-balle, le télescope submersible et le langage de programmation informatique ?
          </strong>
          <br>
          Réponse : <strong>Tous ces produits ont été inventés par des femmes</strong>
          <p>
            Tous ces produits ont été inventés par des femmes, mais souvent on ne trouve pas la réponse car on parle
            toujours des grands inventeurs…
          </p>
          <br>
          <br>
          <strong>8. Dans laquelle de ces professions trouve-t-on le moins d’hommes ?</strong>
          <br>
          Réponse : <strong>Magistrat/e</strong>
          <p>
            Actuellement, plus de 70 % des étudiants/es reçus au concours d’entrée de l’École nationale de la magistrature
            (ENM à Bordeaux) sont des femmes.
          </p>
          <br>
          <br>
          <strong>9. Dans laquelle de ces professions trouve-t-on le moins de femmes ?</strong>
          <br>
          Réponse : <strong>Informaticien/ne</strong>
          <p>
            Actuellement, la profession manque de personnel qualifié et notamment de femmes. Elles constituaient 27 % des
            recrutements en 2013 contre 22 % en 2010
          </p>
          <br>
          <br>
          <strong>10. Quelle est la proportion de femmes parmi les maires de France ?</strong>
          <br>
          Réponse : <strong>16 %</strong>
          <p>
            16 %, seulement. Il y a encore des progrès à faire en matière d’élections. On compte 22 % de sénatrices, 27 %
            de députées à l’Assemblée nationale et 43 % de députées européennes.
          </p>
        </div>


      </div>

    </div>
  </div>

</template>

<script>
export default {
  props: {
    game_id: Number,
  },

  data: function () {
    return {
      customer: Object,
      firstname: String,
      lastname: String,
      phone: "",
      email: String,
      score: 0,
      game: Object,
      questions: Array,
      choices: Array,
      current_question: Object,
      current_question_index: 0,
      current_choices: Array,
      question_count: Number,
      responses: [],
      step: String,
      message: String,
      message_type: "alert-success",
      used_phones: Array,
    }
  },

  mounted() {
    console.log('Component game mounted.');
    this.step = 'presentation';
    this.get_data();
  },

  methods: {

    choice_for_question: function (question_id) {
      const choice_id = this.responses[question_id];
      const choice = this.choices.find(el => el.id == Number(choice_id));
      return choice;
    },

    post_responses: function () {
      const _this = this;
      let url = '/modules/dlnkgames/actions/game.php';

      const data = new FormData();
      data.append('responses', _this.responses);
      data.append('id', _this.game.id);
      data.append('firstname', _this.firstname);
      data.append('lastname', _this.lastname);
      data.append('phone', _this.phone);
      data.append('email', _this.email);
      data.append('submit_responses', '');

      axios({
        method: 'post',
        url: url,
        data: data,
        headers: {"cache-control": "no-cache"},
      })
          .then(function (response) {
            //handle success
            const status = response.data.status
            _this.score = response.data.score

            if (status) {
              _this.step = 'congrats'
            } else {
              _this.message = response.data.error;
              _this.message_type = "alert-danger";
              const element = document.getElementById("alert_message");
              element.classList.remove("d-none");
            }
          })
          .catch(function (response) {
            alert('Erreur inconnu');
          });
    },

    previous_question: function () {
      if (this.current_question_index > 0) {
        this.step = 'quiz';
        this.current_question_index--;
        this.update_question();
      }
    },

    next_question: function () {
      if (this.current_question_index < this.question_count - 1) {
        this.current_question_index++;
        this.update_question();
      }
    },

    select_choice: function (choice_id) {
      this.responses[this.current_question.id] = Number(choice_id);
      this.current_question_index++;
      this.update_question();
    },

    update_question: function () {
      if (this.current_question_index < this.questions.length) {
        this.current_question = this.questions[this.current_question_index];
        this.current_choices = this.choices.filter(el => el.question_id == this.current_question.id);
      } else {
        this.step = 'validation';
      }
    },

    get_data: function () {
      let _this = this;

      let url = '/modules/dlnkgames/actions/game.php?id=' + _this.game_id;

      axios.get(url)
          .then(function (response) {
            _this.customer = response.data.customer
            _this.game = response.data.game
            _this.questions = response.data.questions
            _this.choices = response.data.choices;
            _this.current_question = _this.questions[_this.current_question_index];
            _this.current_choices = _this.choices.filter(el => el.question_id == _this.current_question.id);
            _this.question_count = _this.questions.length;
            _this.used_phones = response.data.used_phones;

            if (typeof _this.customer.firstname !== 'undefined') {
              _this.firstname = _this.customer.firstname;
            } else {
              _this.firstname = "";
            }

            if (typeof _this.customer.lastname !== 'undefined') {
              _this.lastname = _this.customer.lastname;
            } else {
              _this.lastname = "";
            }

            if (typeof _this.customer.email !== 'undefined') {
              _this.email = _this.customer.email;
            } else {
              _this.email = "";
            }

            if (typeof _this.customer.mobile_phone !== 'undefined') {
              _this.phone = _this.customer.mobile_phone;
            } else {
              _this.phone = "";
            }


          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });
    },

    start_quiz: function (event) {
      let _this = this;
      let already_participated;
      event.preventDefault();
      event.stopPropagation();

      if (_this.phone && _this.phone.length > 0) {
        _this.phone.replace(/\s/g, '');
        already_participated = this.used_phones.find(el => el.phone == _this.phone);
      }

      let form = document.getElementById('user_form');

      if (typeof(already_participated) === 'undefined') {
        if (form.checkValidity() === true) {
          event.preventDefault();
          event.stopPropagation();
          _this.step = 'quiz';
        }
        form.classList.add('was-validated');

      } else {
        let el = document.getElementById('phone_feedback');
        el.innerHTML = "Ce numéro de téléphone a déjà été utilisé (une seule participation par personne)";
        $("#phone_feedback").toggle();
        $("#phone").addClass('is-invalid');
        form.classList.add('was-validated');
      }
    },
  }
}
</script>

<style scoped>

@import url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:ital,wght@0,200;0,300;0,400;0,600;0,700;0,900;1,200;1,300;1,400;1,600;1,700;1,900&display=swap");

/*FONT POLICE*/

body {
  font-family: source sans pro, light;
}

h1 {
  font-size: 2rem;
}

h2 {
  line-height: 2.1em;
}

h3 {
  font-size: 1.5rem;
}

p {
  font-size: 1.2em;
  font-weight: 300;
  box-sizing: content-box;
}

a {
  text-decoration: none;
  color: black;
}

.text-vert {
  color: #5aa936;
}

.style-light {
  font-size: 20px;
}

/* IMAGE-p QUIZ */
.png-160-160 {
  height: 160px;
}

/* --- PAGINATION -- */
hr {
  border-top: 3px double #3f661e;
}

.quiz-active {
  padding: 180px;
}

.dinkgames-progress-quiz {
  font-size: 22px;
  background: rgb(194,159,205);
  display: initial;
  line-height: 4rem;
}

/* --- BODY SECTIONS-- */

.ctn-center {
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  background: rgb(194,159,205);
}

.ctn-sub-title {
  text-align: center;
  padding: 25px; /*SECTION PARAGRAPHE - Alignement! */
}

.btn-quiz {
  /*IMPORTANT ! */
  flex: 1 0 45%;
  width: 200px;
  padding: 20px;
  height: 80px;
  border-radius: 5px;
  cursor: pointer;
  border: none;
  margin: 0.4rem;
  outline: none;
  background: #88429d;
  color: white;
  user-select: none;
  font-weight: 600;
}

.btn-quiz:hover {
  background: #590d6f;
  transition: 0.5s;
  color: #ffffff;
}

.quiz-active {
  background: #590d6f;
  color: #ffffff;
}

.bg-button {
  height: 50px;
  background: #88429d;
  border: none;
  border-radius: 6px;
  color: white;
  font-weight: bold;
  font-size: 16px;
  padding-left: 2rem;
  padding-right: 2rem;
}

.bg-button:hover {
  background: #501d5f;
  color: #fff;
}

/* --- PAGE MAIL SHIP -- */

.btn-submit-qz,
.resultat {
  width: 12%;
  height: 7%;
  background: #5aaa33;
  border: none;
  color: #fff;
}

.btn-submit-qz,
.resultat:hover {
  width: 12%;
  height: 7%;
  background: #000;
  border: none;
  color: #ffffff;
}

label {
  line-height: 3.3em; /*important*/
}

.row-cols-6 {
  display: flex;
  width: 100%;
  justify-content: center;
}

.col-1 {
  -ms-flex: 0 0 8.333333%;
  max-width: 1%;
  align-self: center;
}

.svg-left {
  height: 27px;
  margin: 13px;
  transform: rotate(90deg);
  background: #88429d;
}

.svg-right {
  height: 27px;
  margin: 13px;
  background: #88429d;
  transform: rotate(270deg);
}

.titlequiz {
  padding: 10px;
}

img.svg-left,
img.svg-right {
  background: #88429d;
  padding: 12px;
  height: 39px;
  border-radius: 20px;
}

img.svg-left:hover,
img.svg-right:hover {
  background-color: #590d6f;
}


</style>